import { render, staticRenderFns } from "./DispatchTaskModal.vue?vue&type=template&id=4f7d06f4&"
import script from "./DispatchTaskModal.vue?vue&type=script&lang=js&"
export * from "./DispatchTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports